import { MESSAGE_LIMITS } from '../core/constants.js';

export class MessageValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MessageValidationError';
  }
}

export function validateTextMessage(text: string): void {
  if (!text || text.trim() === '') {
    throw new MessageValidationError('Text message cannot be empty');
  }

  if (text.length > MESSAGE_LIMITS.TEXT_MESSAGE_MAX_CHARS) {
    throw new MessageValidationError(
      `Text message cannot exceed ${MESSAGE_LIMITS.TEXT_MESSAGE_MAX_CHARS} characters`
    );
  }
}